import { render } from "./ServiceDetailView.vue?vue&type=template&id=71502cd2&scoped=true"
import script from "./ServiceDetailView.vue?vue&type=script&lang=js"
export * from "./ServiceDetailView.vue?vue&type=script&lang=js"

import "./ServiceDetailView.vue?vue&type=style&index=0&id=71502cd2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71502cd2"]])

export default __exports__